import React from "react";
import { Link } from "react-router-dom";

// Urls
import { RedirectTo } from "../../urls/PageLinksURL";

// Constants and Utils
import { checkIsSellerUser } from "../../utils/SellerUtils";
import { constructRedirectPath } from "../../utils/redirect-utils/RedirectUtils";
import { OrgSettingsIndexes, UrlKeys } from "../../constants/GeneralConstants";
import { useUrlKeyCheck } from "../../mavin/utils/hooks/HooksUtil";
import { checkIsLoggedInUserAdminUser } from "../../common-utils/user-utils/userUtils";

// Page Constants
const {
  orgProfileUrl,
  orgUserListUrl,
  orgSubscriptionUrl,
  orgTargetGroupListUrl,
  orgRoadStretchListUrl,
  orgDataLayerListUrl,
  // orgMediaPricePageUrl,
  orgBuyerListPageUrl,
  orgMediaInventoryPageUrl,
} = RedirectTo;

// org data
const organizationDataConstants = [
  {
    label: "Profile",
    link: orgProfileUrl,
    index: OrgSettingsIndexes.profile,
    icon: "fa-address-card",
  },
  {
    label: "Users & Roles",
    link: orgUserListUrl,
    index: OrgSettingsIndexes.userAndRoles,
    icon: "fa-users",
  },
  {
    label: "Subscription",
    link: orgSubscriptionUrl,
    index: OrgSettingsIndexes.subscription,
    icon: "fa-crown",
  },
];

// buyer data
const orgBuyerDataConstants = [
  {
    label: "Buyers",
    link: orgBuyerListPageUrl,
    index: OrgSettingsIndexes.buyers,
    icon: "fa-cart-plus",
  },
];

// defs data
const definitionsDataConstants = [
  {
    label: "Target Groups",
    link: orgTargetGroupListUrl,
    index: OrgSettingsIndexes.targetGroups,
    icon: "fa-user-tie",
  },
  {
    label: "Road Stretches",
    link: orgRoadStretchListUrl,
    index: OrgSettingsIndexes.roadStretches,
    icon: "fa-road",
  },
  {
    label: "Data Layers",
    link: orgDataLayerListUrl,
    index: OrgSettingsIndexes.dataLayers,
    icon: "fa-layer-group",
  },
];

// media inventory data
const mediaInventoryDataConstants = [
  {
    label: "Media Inventory",
    link: orgMediaInventoryPageUrl,
    index: OrgSettingsIndexes.mediaInventory,
    icon: "fa-images",
  },
];

// inventory data
// const inventoryDataConstants = [
//   {
//     label: "Media Price",
//     link: orgMediaPricePageUrl,
//     index: OrgSettingsIndexes.mediaPrice,
//     icon: "fa-map-marker-alt",
//   },
// ];

// Page Components
function SidebarItemList({ data = [], activeIdx }) {
  // no items
  if (data.length === 0) {
    return null;
  }

  return (
    <>
      {data.map((eachData, i) => {
        const { label, link, index, icon } = eachData;
        const activeClass = activeIdx === index ? "active" : "";
        return (
          <li key={i} className={`nav-item ${activeClass}`}>
            <Link className="nav-link" to={constructRedirectPath(link)}>
              <i className={`fas ${icon}`}></i> {label}
            </Link>
          </li>
        );
      })}
    </>
  );
}

/**
 * Common Sidebar for Organization Settings pages - URL Pattern : "/org/**"
 */
export default function OrgSettingsSidebar({ activeIdx }) {
  // Checking the USER is Seller or not
  const isSellerUser = checkIsSellerUser();

  // Condition to check whether there is Toohl/prooh specific key in the url
  const isToohlSpecific = useUrlKeyCheck(UrlKeys.toohlSpecific);

  // checking the USER is Admin or not
  const isAdminUser = checkIsLoggedInUserAdminUser();

  return (
    <aside className="sidebar bg-alt">
      <ul className="nav flex-column mt-3">
        {/** Org Settings */}
        {isAdminUser && (
          <>
            <li className="nav-item group-header">Organization</li>
            <SidebarItemList
              data={organizationDataConstants}
              activeIdx={activeIdx}
            />
          </>
        )}

        {/* Buyer Manage */}
        {isAdminUser && !isSellerUser && (
          <SidebarItemList data={orgBuyerDataConstants} activeIdx={activeIdx} />
        )}

        {/* Definitions */}
        {!isSellerUser && (
          <>
            <li className="nav-item group-header">Definitions</li>
            <SidebarItemList
              data={definitionsDataConstants}
              activeIdx={activeIdx}
            />
          </>
        )}

        {/* toohl specific */}
        {!isSellerUser && isToohlSpecific && isAdminUser && (
          <>
            <li className="nav-item group-header">Inventory</li>
            <SidebarItemList
              data={mediaInventoryDataConstants}
              activeIdx={activeIdx}
            />
          </>
        )}
      </ul>
    </aside>
  );
}
